import cx from 'classnames';
import { useDrag, useDrop } from 'react-dnd';
import { isMobile, isTablet } from 'react-device-detect';
import { isResponseOk } from '../../../../../../utility/isResponseOk';
import { moveMasterScheduleAssignmentToAnotherCellService } from '../../../../../../services/scheduling';
import dayjs from 'dayjs';

const FirstHalfCell = ({
  cell,
  formData,
  scheduleData,
  getScheduleData,
  selectedUser,
  selectedCells,
  sidebarAction,
  selectedAssignmentsToDelete,
  showNames,
}) => {
  const [collected, drag] = useDrag(
    () => ({
      type: 'master_schedule_one_half_assignment',
      item: { assignment: { ...cell.first_half_user } },
      canDrag: !isMobile && !isTablet && cell.first_half_user,
      end: async (item, monitor) => {
        try {
          const dropResult = monitor.getDropResult();

          const assignments = [];

          scheduleData.units.forEach((unit) => {
            unit.roles.forEach((role) => {
              role.master_scheduling_cells.forEach((cellItem) => {
                if (cellItem.first_half_user && cellItem.first_half_user?.user_id === item.assignment.user_id) {
                  assignments.push({ id: cellItem.first_half_user.id, day: cellItem.day, shift: cellItem.shift, halfPart: 'first_half' });
                }
                if (cellItem.second_half_user && cellItem.second_half_user?.user_id === item.assignment?.user_id) {
                  assignments.push({ id: cellItem.second_half_user.id, day: cellItem.day, shift: cellItem.shift, halfPart: 'second_half' });
                }
                if (cellItem.both_halves_user && cellItem.both_halves_user?.user_id === item.assignment?.user_id) {
                  assignments.push({ id: cellItem.both_halves_user.id, day: cellItem.day, shift: cellItem.shift, halfPart: 'both_halves' });
                }
              });
            });
          });

          if (
            assignments.find((assignmentItem) => {
              return (
                assignmentItem.day === dropResult.cell.day &&
                assignmentItem.shift === dropResult.cell.shift &&
                assignmentItem.id !== item.assignment.id &&
                (assignmentItem.halfPart === 'first_half' || assignmentItem.halfPart === 'both_halves')
              );
            })
          ) {
            return;
          }

          if (dropResult?.cell) {
            const payload = {
              assignment_id: item.assignment.id,
              new_cell_id: dropResult.cell.id,
              half_part: dropResult.halfPart,
            };
            const response = await moveMasterScheduleAssignmentToAnotherCellService(payload);
            if (isResponseOk(response)) {
              getScheduleData();
            }
          }
        } catch (e) {
          console.log(e);
        }
      },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [cell.first_half_user, getScheduleData],
  );

  const [, drop] = useDrop(
    () => ({
      accept: ['master_schedule_one_half_assignment'],
      canDrop: () => !cell.first_half_user,
      drop: () => ({ cell, halfPart: 'first_half' }),
    }),
    [cell.first_half_user],
  );

  return (
    <div
      ref={cell.first_half_user ? drag : drop}
      className={cx('first-half-recurring-shift', {
        'has-user':
          cell.first_half_user || (formData.halfPart?.value === 'first_half' && selectedCells.find((item) => item.id === cell.id)),
        'is-selected': selectedUser && selectedUser?.id === cell.first_half_user?.user_id,
        'is-selecting': !!selectedCells.find((item) => item.id === cell.id) && formData.halfPart?.value === 'first_half',
        'is-deleting':
          (sidebarAction === 'delete' && selectedAssignmentsToDelete.find((item) => item === cell.first_half_user?.id)) ||
          (selectedUser?.id === cell.first_half_user?.user_id &&
            sidebarAction === 'delete' &&
            (formData.deleteOption?.value === 'all_repeated_and_single_shifts' || formData.deleteOption?.value === 'all_repeated_shifts')),
      })}
      style={
        cell.first_half_user
          ? { color: cell.first_half_user.font_color, backgroundColor: cell.first_half_user.cell_color }
          : !!selectedCells.find((item) => item.id === cell.id) && formData.halfPart?.value === 'first_half'
            ? { color: formData.fontColor, backgroundColor: formData.cellColor }
            : undefined
      }
    >
      {cell.first_half_user && dayjs(cell.first_half_user.start_date).isAfter(dayjs(), 'day') && (
        <svg
          style={{ position: 'absolute', top: '2px', right: '2px' }}
          width="8"
          height="8"
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.5 0.5H1.5V2.25L3.1875 4L1.5 5.75V7.5H6.5V5.75L4.8125 4L6.5 2.25V0.5ZM4.25 3.5V5.25L5.67188 6.75H2.3125L3.75 5.25V3.5L2.5 2.25H5.5L4.25 3.5Z"
            fill="#101828"
          />
        </svg>
      )}
      {cell.first_half_user ? (showNames ? cell.first_half_user.full_name : 'X') : ''}
      {formData.halfPart?.value === 'first_half' && selectedCells.find((item) => item.id === cell.id)
        ? showNames
          ? selectedUser?.full_name
          : 'X'
        : ''}
    </div>
  );
};

export default FirstHalfCell;
